import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useNavigate} from '@github-ui/use-navigate'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export function useDashboardUniverse2025ToggleFeaturePreview() {
  const navigate = useNavigate()
  const featurePreviewAvailable = isFeatureEnabled('dashboard_universe_2025')

  const toggleFeaturePreview = async () => {
    await verifiedFetchJSON('/feature_preview/dashboard_universe_2025/toggle', {
      method: 'POST',
    })

    // There's an existing issue with the feature preview toggle endpoint is slow to update the feature preview state
    // so we're adding a delay to ensure the feature preview state is updated before navigating back to the dashboard
    setTimeout(() => {
      navigate('')
    }, 250)
  }

  return featurePreviewAvailable ? toggleFeaturePreview : undefined
}
